import { render, staticRenderFns } from "./CourtArbitrationFillter.vue?vue&type=template&id=a94f4a70&scoped=true&"
import script from "./CourtArbitrationFillter.vue?vue&type=script&lang=js&"
export * from "./CourtArbitrationFillter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94f4a70",
  null
  
)

export default component.exports